import axios from 'axios'
//import QS from 'qs'
import { Loading, Message, MessageBox } from 'element-ui'
//import { Toast,Dialog } from 'vant';


/**
 * 是否存在
 */
export const isNotEmpty = (val) => {
	if (typeof (val) == 'undefined') {
        return false;
        }
        if (val != '' && val != null && val != undefined)
        return true;
        else
        return false;
    }


/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
	if (!name) return;
	return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

/**
 * 获取当前地址和参数
 */
export const getCurrentPageUrlWithArgs = (url) => {

	//所有  包括空的  和undefined
    var paramObj = {};
    var index = url.lastIndexOf("?");
    if(index==-1){
        //没有参数
        return paramObj;
    }
    var paramStr = url.substring(index+1,url.length);
    if(!paramStr){
        //参数为空
        return paramObj;
    }
    var paramArr = paramStr.split('&');
    for (var i = 0; i < paramArr.length; i++) {
        var obj = paramArr[i];
        var objArr = obj.split('=');
        paramObj[objArr[0]] = objArr[1];
    }
    return paramObj;
}

function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}

//格式化日期
export function formatDate(row, column, cellValue, index) {
	if(cellValue==null || cellValue=="") return "";
    let date = new Date(cellValue.replace("T", " ").replace(/-/g, '/'));
    if(!isValidDate(date)){
      date = new Date(cellValue);
    }
    let Y = date.getFullYear() + '-';
    let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
    let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    let m = date.getMinutes()  < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}

//格式化金额格式保留两位小数
export function formatmoney(val) {
    let num = val;
    return num;
}

//格式化金额格式保留小数位数
export function toFixed(val,num) {
    return val.toFixed(num);;
}

//计算时间戳
export function gettimestamp(time) {
    return new Date(time).getTime()

}


/**
 * 设备设备实现不同跳转
 * PC调转到PC页面，移动端跳转到移动页面
 */
export const deviceSpot = (mobile, pc,callback) => {

    if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {  
       //判断是否为移动端的设备，是移动端的话  跳转  mobile 页面
       callback(mobile)                                               
    }else{
        callback(pc)
    }

}

/**
 * 页面滚动条滑动
 * banscroll--禁止滚动，freedscroll---释放滚动
 */
export const banscroll = () => {
    var mo=function(e){e.preventDefault();};
    document.body.style.overflow='hidden';
    //document.addEventListener("touchmove",mo,false);//禁止页面滑动

}
export const freedscroll = () => {
    var mo=function(e){e.preventDefault();};
    document.body.style.overflow='';//出现滚动条
    //document.removeEventListener("touchmove",mo,true);

}




/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
    let target;
    // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
    if (attr === 'scrollTop') {
        target = element.scrollTop;
    }else if(element.currentStyle){
        target = element.currentStyle[attr];
    }else{
        target = document.defaultView.getComputedStyle(element,null)[attr];
    }
    //在获取 opactiy 时需要获取小数 parseFloat
    return  NumberMode == 'float'? parseFloat(target) : parseInt(target);
}

/**
 * 删除确认
 */

export const deleteConfirm = (that, name, callback) => {
    that.$confirm('确认要删除【' + name + '】吗？', '确认删除', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
    }).then(() => {
        callback();
    }).catch(() => {

    });
}

/**
 * 用户登录方法，对应post请求
 * @param {String} sefl [this索引]
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function userlogin(sefl,url, data = {}) {
    // 注：post请求方法有的要求参数格式为formdata格式，此时需要借助 Qs.stringify()方法将对象转换为字符串
    //let obj = QS.stringify(data);
    return new Promise(function (resolve, reject) {
        axios({
            method: 'post',
            url: url,
            data: data,// 传递参数
            // 设置请求头信息
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'json'
        }).then(response => {
            // 请求成功
            resolve(response.data);
            console.log('请求成功饭')

            //sefl.$router.push({name:'list'})
        }).catch(error => {
            // 请求失败，
            console.log('请求失败',error.status);
            reject(error)
        });


    });

}


/**
 * get方法，对应get请求
 * @param {String} sefl [this索引]
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function axiosget(sefl,url, data = {}) {
    var tokendat = getStore('token');

    return new Promise(function (resolve, reject) {
        axios({
            method: 'get',
            url: url,
            params:data,  // 传递参数
            // 设置请求头信息
            headers: {
                'Content-Type': 'application/json',
                //'Authorization': 'Bearer '+tokendat,
            },
            responseType: 'json'
        }).then(response => {
            // 请求成功
            resolve(response.data);

        }).catch(error => {
            // 请求失败，
            console.log('请求失败',error.status);
            //401状态重新登录
            if(error.response.status  == 401){

                Dialog.confirm({
                    title: '提示',
                    message: '身份信息已过期，请重新登陆',
                })
                .then(() => {

                    console.log('确认')
                    //保存路由及全url
                    setStore('to_url',sefl.$route.path);
                    setStore('to_urlparam',window.location.href);
                    to_login(sefl)
                })
                .catch(() => {
                    console.log('取消')
                });

            }

            reject(error)
        });


    });

}


/**
 * post方法，对应post请求
 * @param {String} sefl [this索引]
 * @param {String} url [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function axiospost(sefl,url, data = {}) {
    // 注：post请求方法有的要求参数格式为formdata格式，此时需要借助 Qs.stringify()方法将对象转换为字符串
    var tokendat = getStore('token');
    console.log('token',tokendat)
    //let obj = QS.stringify(data);
    return new Promise(function (resolve, reject) {
        axios({
            method: 'post',
            url: url,
            data: data,// 传递参数
            // 设置请求头信息
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+tokendat,
            },
            responseType: 'json'
        }).then(response => {
            // 请求成功
            resolve(response.data);
            //sefl.$router.push({name:'list'})
        }).catch(error => {
            // 请求失败，
            console.log('请求失败',error.status);
            //401状态重新登录
            if(error.response.status  == 401){

                Dialog.confirm({
                    title: '提示',
                    message: '身份信息已过期，请重新登陆',
                })
                .then(() => {

                    console.log('确认')
                    //保存路由及全url
                    setStore('to_url',sefl.$route.path);
                    setStore('to_urlparam',window.location.href);
                    to_login(sefl)
                })
                .catch(() => {
                    console.log('取消')
                });

            }

            reject(error)
        });


    });

}

export default {
    isNotEmpty,
    setStore,
    getStore,
    removeStore,
    getCurrentPageUrlWithArgs,
    formatDate,
    formatmoney,
    deviceSpot,
    banscroll,
    freedscroll,
    getStyle,
    deleteConfirm,
    userlogin,
    axiosget,
    axiospost,
    toFixed,
    gettimestamp
}







// WEBPACK FOOTER //
// ./src/utils/mUtils.js